/* eslint-disable eslint-comments/no-unlimited-disable */
/* eslint-disable */

const nameCustomElement = "quickview-component";
class QuickviewComponent extends window.HTMLElement {
  connectedCallback() {
    // this.triggerButtonListElems = triggerButtonList;
    this.modalElem = document.querySelector("#quickview-modal");
    this.closeButtonElem = this.modalElem.querySelector("#quickview-close");
    this.quickviewStructureElem = this.modalElem.querySelector("#quickview-structure");
    this.buildModal = this.buildModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.updateQuickview = this.updateQuickview.bind(this);
    this.updateQuantity = this.updateQuantity.bind(this);
    this.addToCart = this.addToCart.bind(this);
    this.addClickEvents();
  }

  addClickEvents() {
    // this.triggerButtonListElems.forEach((button) => {
    const button = this.querySelector("[data-quickview-trigger]");
    button.addEventListener("click", this.buildModal);
    // });

    this.closeButtonElem.addEventListener("click", this.closeModal);
  }

  activeAddToCartEvents() {
    const addToCartButton = this.modalElem.querySelector("#quickview-add-to-cart");

    if (addToCartButton !== null) {
      addToCartButton.addEventListener("click", this.addToCart);
    }
  }

  showError(message) {
    const errorElem = this.modalElem.querySelector("#quickview-error");

    if (errorElem !== null) {
      errorElem.innerHTML = `<span>${message}</span>`;
      errorElem.classList.add("active");

      const disappear = setTimeout(() => {
        errorElem.classList.remove("active");
        clearTimeout(disappear);
      }, 4000);
    }
  }

  async addToCart() {
    const variantElemSelected = this.modalElem.querySelector(".variant--selected") || this.modalElem.querySelector("#quickview-variant-list");
    const variantQuantity = this.modalElem.querySelector("#quantity-input").value;
    const { variantId, variantPrice, variantCompareAtPrice } = variantElemSelected.dataset;

    const variantData = {
      items: [
        {
          id: variantId,
          quantity: variantQuantity,
        },
      ],
    };

    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(variantData),
    };

    try {
      const response = await fetch("/cart/add.js", options);

      if (response.status == 200) {
        const cartData = await response.json();
        const variantData = {
          ...cartData.items[0],
          variantPrice,
          variantCompareAtPrice,
        };

        const responseCurrentCart = await fetch("/cart.js");

        if (responseCurrentCart.status == 200) {
          const currentCartData = await responseCurrentCart.json();
          variantData.totalPrice = currentCartData.total_price;
        }

        // this.showCartNotification(variantData)
      } else {
        const cartError = await response.json();

        cartError.status === 404 ? this.showError(cartError.description) : this.showError("Stock insuficiente.");
      }
    } catch (error) {
      console.error(`Error: ${error}`);
      this.showError(`Ocurrió un error: ${error}`);
    }
  }

  showCartNotification(variant) {
    const notificationElem = document.querySelector("#notification");

    if (notificationElem !== null) {
      const splitTitle = (title) => [title.replace(/^\w+\.\d+\s/, ""), title.match(/^\w+\.\d+/)];

      const imageElem = notificationElem.querySelector("#notif-prod-image");
      const titleElem = notificationElem.querySelector("#notif-prod-title");
      const skuElem = notificationElem.querySelector("#notif-prod-art-number");
      const variantOptionElem = notificationElem.querySelector("#notif-prod-variant");
      const quantityElem = notificationElem.querySelector("#notif-prod-qty");
      const priceWrapperElem = notificationElem.querySelector("#notif-prod-price");
      const priceChildElem = notificationElem.querySelector("[data-price]");
      const subTotalElem = notificationElem.querySelector("#notif-subtotal");

      const [title, sku] = splitTitle(variant.product_title);
      const variantOption = `${variant.options_with_values[0].name}: ${variant.options_with_values[0].value}`;
      const quantity = variant.quantity;
      const totalPrice = formatMoney(variant.totalPrice, "${{amount}}");
      let price = variant.variantPrice;
      let compareAtPrice = variant.variantCompareAtPrice;
      const compareAtPriceExist = compareAtPrice !== "null";
      const discount = Math.round(100 - (price / compareAtPrice) * 100);
      price = formatMoney(price, "${{amount}}");
      compareAtPrice = formatMoney(compareAtPrice, "${{amount}}");

      const fullPriceElem = `
                <div class="price__regular">
                    <dt>
                        <span class="visually-hidden visually-hidden--inline">Precio habitual</span>
                    </dt>
                    <dd>
                        <span class="price-item price-item--regular" data-regular-price="">
                            ${compareAtPriceExist ? compareAtPrice : price}
                        </span>
                    </dd>
                </div>
            `;

      const promoPriceElem = compareAtPriceExist
        ? `<div class="price__sale">
                    <dt>
                        <span class="visually-hidden visually-hidden--inline">${price}</span>
                    </dt>
                    <dd>
                        <span class="price-item price-item--sale" data-sale-price="${price}">
                            ${price}
                        </span>
                        <span class="price-item__label" aria-hidden="true">Oferta</span>
                    </dd>
                </div>`
        : "";

      const discountElem = compareAtPriceExist
        ? `
                 <div class="price price--on-sale">
                    <span class="price-item price-item--sale" data-sale-price="">${discount}% de descuento </span>
                </div>
            `
        : "";

      const priceComponent = `
                <dl class="price ${compareAtPriceExist ? "price--on-sale" : ""}" data-price="">
                    ${fullPriceElem}
                    ${promoPriceElem}
                    ${discountElem}
                </dl>`;

      imageElem.src = variant.featured_image.url;
      titleElem.textContent = title;
      skuElem.textContent = sku;
      variantOptionElem.textContent = variantOption;
      quantityElem.textContent = quantity;
      priceChildElem !== null ? (priceChildElem.innerHTML = priceComponent) : (priceWrapperElem.innerHTML += priceComponent);
      subTotalElem.textContent = totalPrice;

      notificationElem.classList.add("visible", "showme");

      const hide = setTimeout(() => {
        notificationElem.classList.remove("showme");

        const disappear = setTimeout(() => {
          notificationElem.classList.remove("visible");

          clearTimeout(disappear);
        }, 500);

        clearTimeout(hide);
      }, 4000);
    }
  }

  activeVariantEvents() {
    const variantListElem = this.modalElem.querySelectorAll(".quickview__variant-item");

    if (variantListElem.length > 0) {
      variantListElem.forEach((variantElem) => {
        variantElem.addEventListener("click", this.updateQuickview);
      });
    }
  }

  activeQuantityEvents() {
    const quantityControls = this.modalElem.querySelectorAll(".quickview__quantity-control");

    if (quantityControls.length > 0) {
      quantityControls.forEach((control) => {
        control.addEventListener("click", this.updateQuantity);
      });
    }
  }

  updateQuantity(event) {
    const quantityInput = this.modalElem.querySelector("#quantity-input");

    if (quantityInput !== null) {
      if (event.target.classList.contains("control--plus")) {
        quantityInput.value++;
      } else {
        quantityInput.value > 1 ? quantityInput.value-- : (quantityInput.value = 1);
      }
    }
  }

  updateQuickview(event) {
    event.preventDefault();
    const variantElemOldSelected = this.modalElem.querySelector(".variant--selected");
    const variantElemSelected = event.target.closest(".quickview__variant-item");
    const { variantId, variantImageSrc, variantImageAlt, variantPrice, variantCompareAtPrice, variantTitle } = variantElemSelected.dataset;

    variantElemOldSelected.classList.remove("variant--selected");
    variantElemSelected.classList.add("variant--selected");

    this.updateImageComponent(variantImageSrc, variantImageAlt);
    this.updatePriceComponent(variantPrice, variantCompareAtPrice);
    this.updateDetailsComponent(variantTitle);
  }

  updateDetailsComponent(title) {
    const quickviewVariantValue = this.modalElem.querySelector("#quickview-variant-value");

    if (title !== null || title !== undefined) {
      quickviewVariantValue.textContent = title;
    }
  }

  updatePriceComponent(price, compareAtPrice) {
    const compareAtPriceExist = compareAtPrice !== "null";
    const discount = Math.round(100 - (price / compareAtPrice) * 100);
    const priceMoney = formatMoney(price, "${{amount}}");
    const compareAtPriceMoney = formatMoney(compareAtPrice, "${{amount}}");
    const priceElem = this.modalElem.querySelector("#quickview-price");
    const compareAtPriceElem = this.modalElem.querySelector("#quickview-compare-at-price");
    const discountElem = this.modalElem.querySelector("#quickview-discount");

    if (compareAtPriceExist) {
      priceElem.textContent = compareAtPriceMoney;
      compareAtPriceElem.textContent = priceMoney;
      discountElem.textContent = `${discount}% de descuento`;
    } else {
      priceElem.textContent = priceMoney;
    }
  }

  updateImageComponent(imageSrc, imageAlt) {
    const imageElem = this.modalElem.querySelector("#quickview-img");

    if (imageElem !== null) {
      imageElem.src = imageSrc;
      imageElem.alt = imageAlt;
    }
  }

  async buildModal(event) {
    event.preventDefault();
    const quickviewButton = event.target.localName === "button" ? event.target : event.target.closest("button");

    const { productHandle } = quickviewButton.dataset;
    const productData = await this.getProductData(productHandle);
    this.quickviewStructureElem.innerHTML = `
                ${this.buildImageComponent(quickviewButton, productData)}

                <div class="quickview__details">
                    ${this.buildInfoComponent(productData)}
                    ${this.buildMessageComponent(productData)}
                    ${this.buildVariantsComponent(productData)}
                    ${this.buildOptionsComponent(productData)}
                </div>
            `;
    this.activeVariantEvents();
    this.activeQuantityEvents();
    this.activeAddToCartEvents();
    this.showModal();
  }

  buildQuickViewButton(data) {
    if (data.metafields.purchase_only_in_store) {
      return `<div class="quickview__button btn button--add-to-cart" id="quickview-add-to-cart" disabled>Producto a la venta solo en tienda física</div>`;
    }
    return `<button class="quickview__button btn button--add-to-cart" id="quickview-add-to-cart">Agregar a carrito</button>`;
  }

  buildOptionsComponent(data) {
    return `
            <footer class="quickview__options">
                <div class="quickview__quantity-wrapper section-block">
                    <span class="quickview__quantity-label">Cantidad:</span>

                    <div class="quickview__quantity-controls">
                        <button class="quickview__quantity-control control--minus">-</button>
                        <input type="number" class="quickview__quantity-input" id="quantity-input" min="1" value="1">
                        <button class="quickview__quantity-control control--plus">+</button>
                    </div>
                </div>
            </footer>

            <div class="quickview__cart">
                ${this.buildQuickViewButton(data)}
                <div class="quickview__error" id="quickview-error"></div>
                <a href="/products/${data.handle}" class="quickview__product-details">Ver detalles del producto</a>
            </div>
        `;
  }

  buildVariantsComponent(data) {
    const getFirstVariantAvailable = (variantList) => variantList.find((variant) => (variant.available ? variant : null));

    const firstVariantAvailable = getFirstVariantAvailable(data.variants);

    const buildDetails = (optionList) => {
      return optionList
        .map((option) => {
          return `
                    <div class="quickview__variant-details">
                        <strong class="quickview__variant-option">${option.name}:</strong>
                        <span class="quickview__variant-value" id="quickview-variant-value">${firstVariantAvailable.title}</span>
                    </div>
                `;
        })
        .join("");
    };

    const buildVariantsList = (optionList, variantList) => {
      const allOptions = [];

      optionList.forEach((option) => {
        allOptions.push(...option.values);
      });

      return variantList
        .reduce((availableVariants, variant) => {
          if (variant.available) {
            const classVariantSelected = firstVariantAvailable.title === variant.title ? "variant--selected" : "";

            const variantElem = `
                        <li class="quickview__variant-item ${classVariantSelected}"
                            aria-label="${variant.title}"
                            data-balloon-pos="down"
                            data-variant-id="${variant.id}"
                            data-variant-image-src="${variant.featured_image ? variant.featured_image.src : firstVariantAvailable.featured_image.src}"
                            data-variant-image-alt="${variant.featured_image ? variant.featured_image.alt : firstVariantAvailable.featured_image.alt}"
                            data-variant-price="${variant.price}"
                            data-variant-compare-at-price="${variant.compare_at_price}"
                            data-variant-title="${variant.title}"
                                />
                            <img src="${variant.featured_image ? variant.featured_image.src : firstVariantAvailable.featured_image.src}"
                                alt="${variant.featured_image ? variant.featured_image.alt : firstVariantAvailable.featured_image.alt}"
                                class="quickview__variant-image">
                        </li>
                    `;

            availableVariants.push(variantElem);
          }

          return availableVariants;
        }, [])
        .join("");
    };

    return `
            <section class="quickview__variants-wrapper section-block">
                ${firstVariantAvailable !== undefined ? buildDetails(data.options) : ""}

                <ul class="quickview__variant-list" id="quickview-variant-list" data-variant-id="${data.id}">
                    ${buildVariantsList(data.options, data.variants)}
                </ul>
            </section
        `;
  }

  buildMessageComponent(data) {
    const tagsList = data.tags;
    const messageList = theme.strings;
    const messageListElem = [];

    tagsList.forEach((tag) => {
      const tagFormatted = tag.toLowerCase();

      if (messageList.hasOwnProperty(tagFormatted)) {
        messageListElem.push(
          `
                        <section class="quickview__message section-block">
                            <p class="quickview__text">${messageList[tagFormatted]}</p>
                        </section>
                    `
        );
      }
    });

    return messageListElem.join("");
  }

  buildInfoComponent(data) {
    const splitTitle = (title) => [title.replace(/^\w+\.\d+\s/, ""), title.match(/^\w+\.\d+/)];

    const [title, sku] = splitTitle(data.title);
    let price = data.price;
    let compareAtPrice = data.compare_at_price;
    const compareAtPriceExist = compareAtPrice !== null;
    const discount = Math.round(100 - (price / compareAtPrice) * 100);
    price = formatMoney(price, "${{amount}}");
    compareAtPrice = formatMoney(compareAtPrice, "${{amount}}");

    const fullPriceElem = `
            <span class="quickview__price ${compareAtPriceExist ? "price--promo" : ""}" id="quickview-price">${compareAtPriceExist ? compareAtPrice : price}</span>`;

    const promoPriceElem = compareAtPriceExist ? `<span class="quickview__compare_at_price" id="quickview-compare-at-price">${price}</span>` : "";

    const discountElem = compareAtPriceExist ? `<span class="quickview__discount" id="quickview-discount">${discount}% de descuento</span>` : "";

    return `
            <header class="quickview__product-info section-block">
                <h2 class="quickview__name">${title}</h2>
                <span class="quickview__sku">${sku}</span>

                <div class="quickview__price-wrapper">
                    ${fullPriceElem}
                    ${promoPriceElem}
                    ${discountElem}
                </div>
            </header>`;
  }

  buildImageComponent(handleElem, data) {
    const getImageName = (url) => {
      // Usar split para dividir la URL por los "/"
      const parts = url.split("/");
      // El último elemento del array es el nombre del archivo con parámetros
      const nameWithParams = parts.pop();
      // Eliminar los parámetros de la consulta si existen
      const nameFile = nameWithParams.split("?")[0];
      // Encontrar la última ocurrencia de un punto
      const lastDot = nameFile.lastIndexOf(".");
      // Si hay un punto, eliminar la extensión
      if (lastDot !== -1) {
        return nameFile.substring(0, lastDot);
      }
      return nameFile;
    };

    const productImageElem = handleElem.closest(".product-card").querySelector(".product-card-image");
    const productImageName = getImageName(productImageElem.src);
    const imageSrcListNames = data.images.map((imageSrc) => {
      return getImageName(imageSrc);
    });
    const imageSrcIndex = imageSrcListNames.findIndex((imageSrc) => productImageName.includes(imageSrc));
    const imageSrc = data.images[imageSrcIndex] || data.featured_image;
    const imageAlt = data.title;

    return `
            <figure class="quickview__image section-block">
                <img src="${imageSrc}"
                    alt="${imageAlt}"
                    class="quickview__img"
                    id="quickview-img"
                    loading="lazy" />
            </figure>
            `;
  }

  async getProductData(handle) {
    try {
      const request = await fetch(`/products/${handle}.js`);

      if (request.status !== 200) {
        this.showError("Error en la solicitud");
        return null;
      }

      const productData = await request.json();
      const requestMetafields = await fetch(`/products/${handle}?view=metafields`);

      if (requestMetafields.status == 200) {
        const metafieldData = await requestMetafields.json();
        productData.metafields = metafieldData;
      }

      return productData;
    } catch (error) {
      console.error(`Error: ${error}`);
      this.showError(`Ocurrió un error: ${error}`);
    }
  }

  showModal() {
    this.modalElem.classList.add("active");
  }

  closeModal() {
    this.modalElem.classList.remove("active");
  }
}

if (!window.customElements.get(nameCustomElement)) {
  window.customElements.define(nameCustomElement, QuickviewComponent);
}
